import { linkFieldsToLinkType } from '@/helpers/transforms'
import type { TextCTABlock as TextCTABlockType } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import TextCTABlock from '../blocks/TextCTABlock'

export const TextCTAConverter: JSXConverter<SerializedBlockNode<TextCTABlockType>> = ({ node }) => {
	const { cta, link } = node.fields
	const linkData = linkFieldsToLinkType(link)

	return <TextCTABlock heading={cta} link={linkData} />
}
